import * as ACTIONS from "@iso/redux/medias/actionTypes";

const initialState = {
  medias: {
    list: [],
    total: 0,
  },
};

function mediaReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_MEDIAS_SUCCESS: {
      return {
        ...state,
        ...{ medias: payload },
      };
    }

    default:
      return state;
  }
}

export default mediaReducer;
